/**
 * Generic error class meant to indicate error conditions that are not breaking
 * 'breaking' meaning should not crash the app but are still meant to be sent to
 * logger for tracking
 */
class InfoError extends Error {
  constructor(...params) {
    super(...params);

    this.name = 'InfoError';
  }
}

export default InfoError;
